var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8 2.80664H16.2C17.19 2.80664 18 3.58101 18 4.54679V14.9877C18 15.9487 17.1941 16.7278 16.2 16.7278H1.8C0.805887 16.7278 0 15.9487 0 14.9877V4.54679C0 3.58101 0.801 2.80664 1.8 2.80664ZM16.2 6.28694H1.8V4.54679H16.2V6.28694ZM16.2 14.9877H1.8V9.76724H16.2V14.9877Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 18,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8 2.80664H16.2C17.19 2.80664 18 3.58101 18 4.54679V14.9877C18 15.9487 17.1941 16.7278 16.2 16.7278H1.8C0.805887 16.7278 0 15.9487 0 14.9877V4.54679C0 3.58101 0.801 2.80664 1.8 2.80664ZM16.2 6.28694H1.8V4.54679H16.2V6.28694ZM16.2 14.9877H1.8V9.76724H16.2V14.9877Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.873138,
    width: 18,
    height: 17.4015,
    fill: "#FACD5D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.21a58f333114a07289bfac49ff2983bf.svg";
export { ForwardRef as ReactComponent };